import { MAX_PRODUCTS_TO_COMPARE, EMPTY_SLOT_NUMBER_TEMPLATE } from "./constants.js";
const getCompareProductsDisplayUrl = (compareProductsDisplayBaseUrl, products) => {
  const partNumbers = products.slice(0, MAX_PRODUCTS_TO_COMPARE).map((product) => product.partNumber).join(",");
  return `${compareProductsDisplayBaseUrl}${partNumbers}`;
};
const replaceSubstring = (text, target, replacement) => {
  return text.replace(new RegExp(target, "g"), replacement);
};
const getEmptySlotText = (emptySlotTemplateText, slotNumber) => {
  return replaceSubstring(
    emptySlotTemplateText,
    EMPTY_SLOT_NUMBER_TEMPLATE,
    slotNumber.toString()
  );
};
export {
  getCompareProductsDisplayUrl,
  getEmptySlotText,
  replaceSubstring
};
